import SVGLayeredCountryMap from './SVGLayeredCountryMap';

export default SVGLayeredCountryMap;
